import { render, staticRenderFns } from "./RelatedToList.vue?vue&type=template&id=26bd53a9&scoped=true"
import script from "./RelatedToList.vue?vue&type=script&lang=js"
export * from "./RelatedToList.vue?vue&type=script&lang=js"
import style0 from "./RelatedToList.vue?vue&type=style&index=0&id=26bd53a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bd53a9",
  null
  
)

export default component.exports